import { create } from '@bufbuild/protobuf';

import { wsAppRequestManager } from '../WsAppApi';
import { RealtimeEventsSubscribeRequestSchema } from '../types/realtime_event/realtime_event_requests_pb';
import { RealtimeEventsSubscribeResponse } from '../types/realtime_event/realtime_event_responses_pb';

export function subscribeRealtimeEventsRequest(): Promise<RealtimeEventsSubscribeResponse> {
  return wsAppRequestManager.request<RealtimeEventsSubscribeResponse>(
    {
      case: 'realtimeEventsSubscribe',
      value: create(RealtimeEventsSubscribeRequestSchema, {}),
    },
    true
  );
}
